export enum NotationWidgetActionType {
  SetTitleText = 'set_title_text',
  SetDescriptionText = 'set_description_text',
  SetHeight = 'set_height',
  SetWidth = 'set_width',
  SetInitialData = 'set_initial_data',
  SetAlertPermissions = 'set_alert_permissions',
  SetUpdatePermissions = 'set_update_permissions',
  SetEncouragementPermissions = 'set_encouragement_permissions',
  SetIsLoading = 'set_is_loading',
  SetCurrentStep = 'set_current_step',
}
